/* eslint-disable import/no-cycle */
import {getAgentSignature} from '../../helpers/getAgentSignature';
import {QuoteTemplateParams} from '../quoteTemplateParams';
import {highlightYellow} from '../../helpers/highlightYellow';
import {getHowToReadQuotesVideo} from '../../helpers/getHowToReadQuotesVideo';
import {getNextStepsVideo} from '../../helpers/getNextStepsVideo';
import {
    emailHeaderCompanyLogo,
    quoteGreeting,
    quoteDiscussionReview,
    quoteIntroVideo,
    quoteNextSteps,
    aboutAmplify,
    illnessBrochure,
} from '../../helpers/commonEmailComponents';

export default function quoteIULTermBlend(params: QuoteTemplateParams) {
    const {
        name,
        face_amount: faceAmount,
        monthly_premium: monthlyPremium,
        brochureLink,
        illnessSection,
        term_period,
        life_coverage,
        life_premium,
        cash_value,
        cash_age,
    } = params;

    return `
${emailHeaderCompanyLogo}
<p>Hi ${highlightYellow(name)},</p>
${quoteGreeting}
${quoteDiscussionReview}
${quoteIntroVideo}
<p><strong>Our life insurance policies provide:</strong></p>
<ol>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Coverage that lasts for the rest of your life</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Pays out for life, critical, chronic, and terminal illness emergencies</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">A savings account that can be accessed in cash tax-free after 10 years (available for select plans)</span></li>
</ol>
<p><strong>Life insurance plan option for ${highlightYellow(name)}</strong></p>
<ul>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        faceAmount,
    )}</span><span style="font-weight: 400;"> life, critical, chronic, and terminal illness protection for the next ${highlightYellow(
        term_period,
    )} years, after ${highlightYellow(term_period)} years you will still have ${highlightYellow(
        life_coverage,
    )} remaining coverage for the rest of life</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        cash_value,
    )} tax-free retirement cash at age ${highlightYellow(cash_age)}</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        monthlyPremium,
    )} per month (for the first ${highlightYellow(term_period)} years), after ${highlightYellow(
        term_period,
    )} years your premium drops to ${highlightYellow(life_premium)} per month for rest of life </span></li>
</ul>
${getHowToReadQuotesVideo(params)}
${quoteNextSteps}
${getNextStepsVideo()}
${aboutAmplify}
${illnessBrochure(illnessSection, brochureLink)}
<p><span style="font-weight: 400;">Please let me know if you have any additional questions. Otherwise looking forward to speaking with you again ${highlightYellow(
        'on Friday',
    )} to help you find a plan that best fits your needs.</span></p>
<p><span style="font-weight: 400;">Best,</span></p>
${getAgentSignature()}
	`;
}
